import React from "react";
import classNames from "classnames";

import {FacebookIcon, InstagramIcon, LinkedinIcon, XIcon, YouTubeIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {FOOTER_TEST_IDS} from "@pg-mono/test-ids";

import {FooterContactBox} from "./FooterContactBox";
import {FooterMenuElement, IFooterMenuElement} from "./FooterMenuElement";
import {FooterPanelExpandable} from "./FooterPanelExpandable";

import * as styles from "./Footer.module.css";

const logoRp = require("./Logo-DefaultTextLite.svg");

export interface IProps {
    footerMenuData: IFooterMenuData;
    hide?: boolean;
    publisherInfo?: string;
    contactInfoLines?: string[];
    className?: string;
    logoSrc?: string;
    langSwitcher?: React.ReactNode;
}

export interface IFooterMenuData {
    various: IFooterMenuElement[];
    cityOffers: IFooterMenuElement[];
    promotions: IFooterMenuElement[];
    info: IFooterMenuElement[];
    cooperation: IFooterMenuElement[];
    topArticles?: IFooterMenuElement[];
}

const panelTitles = {
    offers: "Oferty",
    promotions: "Oferty specjalne",
    info: "Informacje",
    cooperation: "Współpraca",
    topArticles: "Top artykuły"
};

const defaultPublisherInfo = "Wydawcą portalu rynekpierwotny.pl jest PropertyGroup Sp. z o.o.";

const defaultContactInfoLines = ["Tel.: +48 22 825 60 71", "Kontakt w dni robocze: 9:00 – 17:00", "E-mail: biuro@rynekpierwotny.pl"];

const socialIcons = [
    {
        icon: <FacebookIcon fill="var(--colors-white)" size="3" />,
        url: "https://www.facebook.com/rynekpierwotnypl/"
    },
    {
        icon: <InstagramIcon fill="var(--colors-white)" size="3" />,
        url: "https://www.instagram.com/rynekpierwotny/"
    },
    {
        icon: <LinkedinIcon fill="var(--colors-white)" size="3" />,
        url: "https://www.linkedin.com/company/rynekpierwotny-com/"
    },
    {
        icon: <YouTubeIcon fill="var(--colors-white)" size="3" />,
        url: "https://www.youtube.com/@MisjaMieszkanie/"
    },
    {
        icon: <XIcon fill="var(--colors-secondary)" wrapperColor="var(--colors-white)" wrapperSize="2.6" size="2.6" />,
        url: "https://x.com/rynekpierwotny"
    }
];

export const Footer = (props: IProps) => {
    const {footerMenuData, hide, publisherInfo = defaultPublisherInfo, contactInfoLines = defaultContactInfoLines, className, logoSrc, langSwitcher} = props;

    if (hide) return null;

    const {various, cityOffers, promotions, info, cooperation, topArticles} = footerMenuData;

    return (
        <footer className={classNames(styles.footer, className)}>
            <div className={styles.panelsWrap}>
                <div className={styles.column}>
                    <img
                        className={classNames(styles.logo, langSwitcher && styles.logoWithLangSwitcher)}
                        height="60px"
                        width="196px"
                        src={logoSrc || logoRp}
                        alt="logo"
                    />

                    {langSwitcher && <div className={styles.langSwitcherWrap}>{langSwitcher}</div>}
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.offers}>
                        <ul className={styles.panelList}>
                            {various.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                            {cityOffers.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.promotions}>
                        <ul className={styles.panelList}>
                            {promotions.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>

                    <FooterPanelExpandable className={styles.panelMarginMid} title={panelTitles.info}>
                        <ul className={styles.panelList}>
                            {info.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.cooperation}>
                        <ul className={styles.panelList}>
                            {cooperation.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>

                    {topArticles && topArticles.length > 0 && (
                        <FooterPanelExpandable className={styles.panelMarginMid} title={panelTitles.topArticles}>
                            <ul className={styles.panelList}>
                                {topArticles.map((element) => (
                                    <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                                ))}
                            </ul>
                        </FooterPanelExpandable>
                    )}

                    <FooterContactBox lines={contactInfoLines} className={styles.contactBox} />

                    <div className={styles.socialIconsHolder}>
                        {socialIcons.map((socialIcon) => (
                            <a
                                className={styles.socialIcon}
                                key={socialIcon.url}
                                href={socialIcon.url}
                                target="_blank"
                                rel="nofollow"
                                data-testid={FOOTER_TEST_IDS.FOOTER_SOCIAL_ICON}
                            >
                                {socialIcon.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            <div className={styles.copyrightHolder}>
                <Text variant="info_txt_1" as="div" className={styles.copyright}>
                    {publisherInfo}
                </Text>
            </div>
        </footer>
    );
};
import React from "react";
import classNames from "classnames";

import {FacebookIcon, InstagramIcon, LinkedinIcon, XIcon, YouTubeIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {FOOTER_TEST_IDS} from "@pg-mono/test-ids";

import {FooterContactBox} from "./FooterContactBox";
import {FooterMenuElement, IFooterMenuElement} from "./FooterMenuElement";
import {FooterPanelExpandable} from "./FooterPanelExpandable";

import * as styles from "./Footer.module.css";

const logoRp = require("./Logo-DefaultTextLite.svg");

export interface IProps {
    footerMenuData: IFooterMenuData;
    hide?: boolean;
    publisherInfo?: string;
    contactInfoLines?: string[];
    className?: string;
    logoSrc?: string;
    langSwitcher?: React.ReactNode;
}

export interface IFooterMenuData {
    various: IFooterMenuElement[];
    cityOffers: IFooterMenuElement[];
    promotions: IFooterMenuElement[];
    info: IFooterMenuElement[];
    cooperation: IFooterMenuElement[];
    topArticles?: IFooterMenuElement[];
}

const panelTitles = {
    offers: "Oferty",
    promotions: "Oferty specjalne",
    info: "Informacje",
    cooperation: "Współpraca",
    topArticles: "Top artykuły"
};

const defaultPublisherInfo = "Wydawcą portalu rynekpierwotny.pl jest PropertyGroup Sp. z o.o.";

const defaultContactInfoLines = ["Tel.: +48 22 825 60 71", "Kontakt w dni robocze: 9:00 – 17:00", "E-mail: biuro@rynekpierwotny.pl"];

const socialIcons = [
    {
        icon: <FacebookIcon fill="var(--colors-white)" size="3" />,
        url: "https://www.facebook.com/rynekpierwotnypl/"
    },
    {
        icon: <InstagramIcon fill="var(--colors-white)" size="3" />,
        url: "https://www.instagram.com/rynekpierwotny/"
    },
    {
        icon: <LinkedinIcon fill="var(--colors-white)" size="3" />,
        url: "https://www.linkedin.com/company/rynekpierwotny-com/"
    },
    {
        icon: <YouTubeIcon fill="var(--colors-white)" size="3" />,
        url: "https://www.youtube.com/@MisjaMieszkanie/"
    },
    {
        icon: <XIcon fill="var(--colors-secondary)" wrapperColor="var(--colors-white)" wrapperSize="2.6" size="2.6" />,
        url: "https://x.com/rynekpierwotny"
    }
];

export const Footer = (props: IProps) => {
    const {footerMenuData, hide, publisherInfo = defaultPublisherInfo, contactInfoLines = defaultContactInfoLines, className, logoSrc, langSwitcher} = props;

    if (hide) return null;

    const {various, cityOffers, promotions, info, cooperation, topArticles} = footerMenuData;

    return (
        <footer className={classNames(styles.footer, className)}>
            <div className={styles.panelsWrap}>
                <div className={styles.column}>
                    <img
                        className={classNames(styles.logo, langSwitcher && styles.logoWithLangSwitcher)}
                        height="60px"
                        width="196px"
                        src={logoSrc || logoRp}
                        alt="logo"
                    />

                    {langSwitcher && <div className={styles.langSwitcherWrap}>{langSwitcher}</div>}
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.offers}>
                        <ul className={styles.panelList}>
                            {various.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                            {cityOffers.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.promotions}>
                        <ul className={styles.panelList}>
                            {promotions.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>

                    <FooterPanelExpandable className={styles.panelMarginMid} title={panelTitles.info}>
                        <ul className={styles.panelList}>
                            {info.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>
                </div>

                <div className={styles.column}>
                    <FooterPanelExpandable title={panelTitles.cooperation}>
                        <ul className={styles.panelList}>
                            {cooperation.map((element) => (
                                <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                            ))}
                        </ul>
                    </FooterPanelExpandable>

                    {topArticles && topArticles.length > 0 && (
                        <FooterPanelExpandable className={styles.panelMarginMid} title={panelTitles.topArticles}>
                            <ul className={styles.panelList}>
                                {topArticles.map((element) => (
                                    <FooterMenuElement key={element.title.toLowerCase()} {...element} />
                                ))}
                            </ul>
                        </FooterPanelExpandable>
                    )}

                    <FooterContactBox lines={contactInfoLines} className={styles.contactBox} />

                    <div className={styles.socialIconsHolder}>
                        {socialIcons.map((socialIcon) => (
                            <a
                                className={styles.socialIcon}
                                key={socialIcon.url}
                                href={socialIcon.url}
                                target="_blank"
                                rel="nofollow"
                                data-testid={FOOTER_TEST_IDS.FOOTER_SOCIAL_ICON}
                            >
                                {socialIcon.icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            <div className={styles.copyrightHolder}>
                <Text variant="info_txt_1" as="div" className={styles.copyright}>
                    {publisherInfo}
                </Text>
            </div>
        </footer>
    );
};
